export function intercomScript() {
  const w = window;
  const ic = w.Intercom;

  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    const i = function (...args) {
      i.c(args);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;

    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    const appId = CONFIG.INTERCOM_APP_ID;
    s.src = `https://widget.intercom.io/widget/${appId}`;
    const x = d.getElementsByTagName('script')[0];
    if (x.parentNode) {
      x.parentNode.insertBefore(s, x);
    }
  }
}
